import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import "@/assets/iconfont/iconfont.css";
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css';
import "./style/reset.css";
import MD5 from "js-md5";

let IP=process.env.VUE_APP_BASE_URL
Vue.prototype.IP = IP;
Vue.prototype.md5 = MD5;

Vue.config.productionTip = false
Vue.use(ElementUI);

// 全局事件总线
Vue.prototype.$bus = new Vue();

// 按钮权限指令：v-permission="'system:user:add'" 或 v-permission="['a','b']"
Vue.directive('permission', {
    inserted(el, binding) {
        const value = binding.value;
        const userPermissions = store.getters.permissions || [];

        // 允许字符串(单权限)或数组(任一命中即通过)
        const hasPermission = Array.isArray(value)
            ? value.some((item) => userPermissions.includes(item))
            : userPermissions.includes(value);

        if (!hasPermission && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }
});

// 角色指令：v-role="'sys:inventoryAuditor'" 或 v-role="['a','b']"
Vue.directive('role', {
    inserted(el, binding) {
        const value = binding.value;
        const rolesList = store.getters.rolesList || [];

        // 提取角色key列表
        const roleKeys = rolesList.map(role => role.roleKey || role.key || '').filter(Boolean);

        // 允许字符串(单角色)或数组(任一命中即通过)
        const hasRole = Array.isArray(value)
            ? value.some((item) => roleKeys.includes(item))
            : roleKeys.includes(value);

        if (!hasRole && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')